import 'components/styles/extra/ant-design/ant-design'
import 'components/styles/extra/ant-design/ant-design-motion'
import 'components/styles/extra/ant-design/day-picker'
import 'components/styles/extra/ant-design/common'



// WEBPACK FOOTER //
// ./src/components/styles/extra/ant-design/index.js